import React, {ReactNode} from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './ProgressBar.module.scss';

interface IProgressBarProps {
    percent: number;
    title?: ReactNode;
    className?: string;
}

const ProgressBar: React.FC<IProgressBarProps> = ({percent, title, className}) => {
    const safePercent = Math.max(0, Math.min(100, Math.round(percent)));

    return (
        <div className={cn(styles.wrapper, className)}>
            {title && <p className={styles.title}>{title}</p>}
            <div className={styles.row}>
                <div className={styles.track}>
                    <div
                        className={cn(styles.fill, {[styles.fillEn]: isTranslate()})}
                        style={{width: `${safePercent}%`}}
                    />
                </div>
                <span className={styles.label}>{safePercent}%</span>
            </div>
        </div>
    );
};

export default ProgressBar;
